module.exports = __webpack_public_path__ + "img/main_alt.b6deaf3e.svg";